import React from 'react';
import styled from 'styled-components';
import { Body2, Subtitle1, Icon } from 'ensightful-koala-ui';

const GroupCard = styled.div`
    height: fit-content;
    padding: 32px;
    width: 100%;
    background: #ffffff;
    border-radius: 12px;
    ${(props) =>
        props.editOption
            ? 'box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.03);'
            : 'border: 1px solid #E0E0E0;'}
`;

const MemberText = styled.p`
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #757575;
    margin-top: 8px;
    margin-bottom: 0;
`;

const MemberListText = styled.span`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #757575;
    display: flex;
`;

const MemberListTextContainer = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
`;

const MemberContainer = styled.div``;

const GroupCardTopContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    gap: 8px;

    & svg:hover {
        cursor: pointer;
    }
`;

const GroupCards = ({ teamList = [], editOption = true, handleEditTeamButtonClick }) => {
    const renderMembers = (members = []) => {
        return members.map((member, index) => {
            return (
                <MemberListText key={member?.id}>
                    {`${member?.name || member?.display_name || member?.first_name || member?.email || 'No name'}`}
                    {index < members.length - 1 && <Body2 style={{ margin: '0px 8px', color: '#E0E0E0' }}>/</Body2>}
                </MemberListText>
            );
        });
    };
    return teamList.map((team) => (
        <GroupCard key={team.id} editOption={editOption}>
            <GroupCardTopContainer>
                <Subtitle1> {team.name}</Subtitle1>
                <Icon
                    style={{ visibility: editOption ? 'visible' : 'hidden' }}
                    kind={'edit'}
                    fill={'#212121'}
                    onClick={() => handleEditTeamButtonClick(team.id)}
                />
            </GroupCardTopContainer>
            <MemberContainer>
                <MemberText>Members ({team.members.length || 0}): </MemberText>
                <MemberListTextContainer> {renderMembers(team.members)} </MemberListTextContainer>
            </MemberContainer>
        </GroupCard>
    ));
};

export default GroupCards;
